import React, { useState } from "react";
import Layout from "../../components/layout";
import KrogerMainBanner from "../../components/kroger-case-study/page-main-banner";
import KrogerCsIntro from "../../components/kroger-case-study/cs-intro";
import KrogerCsEbusiness from "../../components/kroger-case-study/cs-ebusiness";
import KrogerCsMobileIntro from "../../components/kroger-case-study/cs-mobile-intro";
import KrogerCsServices from "../../components/kroger-case-study/cs-services";
import KrogerCsImpact from "../../components/kroger-case-study/cs-impact";
import SEO from '../../components/seo';
import FormSection from "../../components/common/templates/form/form-section";
import StickyCTA from "../../components/common/templates/sticky-cta-section";


function KrogerCaseStudy({ location }) {
  const [isLoaded, setIsLoaded] = useState(false);
  return (
    <Layout addBodyClass="kroger-case-study-page-template transparent-header" footerFormType="basic" onLoad={() => setIsLoaded(true)}>
      <SEO description="How Rapidops helped a US retail giant deliver hands-free shopping experiences?"
        meta={[{ name: "charSet", content: "utf-8" }]}
        title="Grocery shopping with Voice-Assistant - US Retail Giant" />
      <KrogerMainBanner />
      <KrogerCsIntro isLoaded={isLoaded} />
      <KrogerCsEbusiness isLoaded={isLoaded} />
      <KrogerCsMobileIntro isLoaded={isLoaded} />
      <KrogerCsServices isLoaded={isLoaded} />
      <KrogerCsImpact isLoaded={isLoaded} />
      {/*<FormSection location={location} className="site-footer-form" />*/}
      {/* <StickyCTA /> */}
    </Layout>
  );
}

export default KrogerCaseStudy;
